export function getContextualUrl(prompt: string): string {
  const norm = (prompt || "").toLowerCase();

  // 1. Cockpit / Dashboard / Control Panel
  if (norm.includes("cockpit") || norm.includes("dashboard") || norm.includes("control center") || norm.includes("command center") || norm.includes("painel") || norm.includes("controle") || norm.includes("apex")) {
    return "https://images.unsplash.com/photo-1551288049-bebda4e38f71?auto=format&fit=crop&q=80&w=1200";
  }

  // 2. Growth / Graph / Money / Revenue / Scale
  if (norm.includes("growth") || norm.includes("financial") || norm.includes("charts") || norm.includes("wealth") || norm.includes("scale") || norm.includes("glowing emerald") || norm.includes("escala") || norm.includes("faturamento") || norm.includes("crescimento") || norm.includes("lucro") || norm.includes("conversão")) {
    return "https://images.unsplash.com/photo-1611974789855-9c2a0a7236a3?auto=format&fit=crop&q=80&w=1200";
  }

  // 3. AI Neural Network / Brain / Nodes
  if (norm.includes("brain") || norm.includes("neural") || norm.includes("network") || norm.includes("intelligence") || norm.includes("inteligência") || norm.includes("ia") || norm.includes("nodes")) {
    return "https://images.unsplash.com/photo-1677442136019-21780ecad995?auto=format&fit=crop&q=80&w=1200";
  }

  // 4. Optimization / Web Analytics / Dev / Code / Speed
  if (norm.includes("otimização") || norm.includes("otimiza") || norm.includes("optimize") || norm.includes("performance") || norm.includes("speed") || norm.includes("velocidade") || norm.includes("funnel") || norm.includes("tráfego")) {
    return "https://images.unsplash.com/photo-1460925895917-afdab827c52f?auto=format&fit=crop&q=80&w=1200";
  }

  return "https://images.unsplash.com/photo-1518770660439-4636190af475?auto=format&fit=crop&q=80&w=1200";
}

export async function generateAppImage(prompt: string, retryCount = 0): Promise<string | null> {
  const customFallback = getContextualUrl(prompt);

  try {
    const response = await fetch('/api/ai/image', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ prompt })
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data.url || customFallback;
  } catch (error: any) {
    console.warn("AI Image Generation failed, using contextual fallback:", error.message);
    
    // Always return a highly contextual fallback to keep the UI looking gorgeous
    return customFallback;
  }
}
